module.exports = __webpack_public_path__ + "workspace/static/img/renewalManagerFive.e34634f.png";